import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProtectedLayout({ children }) {
  const token = useSelector((state) => state.adminUser.token);
  const location = useLocation();

  // ✅ Allow admin login page without token
  if (location.pathname === "/admin/login") {
    return children;
  }

  // ✅ Protect all other admin routes
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
